import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';
import { posthog } from '@/integrations/posthog';
import { appendPostHogSessionReplayToSentryEvent } from '@/integrations/posthog/posthogSentry';
import { SENTRY_APPLICATION_KEY } from '@/integrations/sentry/constants';
import { environment } from '@/utils/env.utils';

export const initializeSentry = () =>
  Sentry.init({
    dsn: 'https://c8f856b141cd11db8e8f2f0e1b95fe41@o4506580694990848.ingest.sentry.io/4506592748830720',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.zodErrorsIntegration(),
      // The Sentry Vite plugin only tags first-party code in `vite build` output, so in the dev server every frame would look third-party.
      ...(import.meta.env.DEV
        ? []
        : [
            Sentry.thirdPartyErrorFilterIntegration({
              filterKeys: [SENTRY_APPLICATION_KEY],
              behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
            }),
          ]),
    ],
    beforeSend(event) {
      appendPostHogSessionReplayToSentryEvent(event, posthog);

      return event;
    },
    // Set tracesSampleRate to 0.01 to capture 1%
    // of transactions for performance monitoring.
    tracesSampleRate: 0.01,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [environment.apiRoot],
    environment: environment.env,
    release: environment.version,
  });
